import React from 'react';
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-100 py-10" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-30">
          <div className="mb-6 md:mb-0" data-id="element-31">
            <div className="text-lg font-bold text-gray-900 mb-1" data-id="element-32">
              Contextuality AI
            </div>
            <div className="text-sm text-gray-600" data-id="element-33">
              © {currentYear} Contextuality AI. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>;
};